import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ErrorHandler, ConfirmDialog as ModalDelete } from '@playbookux/playbook-web-core';
import { useQuery } from '@apollo/client';
import { compose } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import GroupsTable from '../../../groups-table';
import {
  GET_PAGINATED_TEMPLATES,
} from '../../../../../../core/graphql/templates';
import {
  Container,
  Loader,
  ZeroState,
  ContainerLoading,
} from '../../../styles';
import {
  TEMPLATES_LIMIT,
  TEMPLATES_ORDER_BY,
  TEMPLATES_INITIAL_ITEMS_OFFSET,
} from './constants';

const TemplateBody = ({
  noItemsMessage,
  templateType,
  companyId,
  onEditTemplate,
  onDeleteTemplate,
  deleteTemplateError,
  deleteTemplateLoading,
}) => {
  const [isModalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [currentTemplateId, setCurrentTemplateId] = useState(null);

  const formattedTemplateType = templateType.toLowerCase();

  const {
    data = {},
    error,
    loading,
  } = useQuery(GET_PAGINATED_TEMPLATES, {
    variables: {
      companyId,
      templateType: formattedTemplateType.toLowerCase(),
      limit: TEMPLATES_LIMIT,
      offset: TEMPLATES_INITIAL_ITEMS_OFFSET,
      order: TEMPLATES_ORDER_BY,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    // FIXME: The moment we refactor the templates, make sure the template test and audience does not call using templateType = consent
    skip: !templateType || templateType === 'consent',
  });

  const { templates = [] } = data;

  const handleOpenModalDelete = (id) => {
    setCurrentTemplateId(id);
    setModalDeleteOpen(true);
  };

  const handleCloseModalDelete = () => {
    setModalDeleteOpen(false);
  };

  const handleConfirmDeleteTemplate = () => {
    onDeleteTemplate(currentTemplateId);
    setCurrentTemplateId(null);
    handleCloseModalDelete();
  };

  if (error) {
    return (
      <Container center>
        <ErrorHandler
          error={error}
          defaultMessage="Error while retrieving templates."
        />
      </Container>
    );
  }

  return (
    <>
      {
        loading && (
          <ContainerLoading>
            <Loader active data-loader="template-body-loader" />
          </ContainerLoading>
        )
      }
      <GroupsTable
        currentCompany={companyId}
        grouped={templates}
        handleOpenModalDelete={handleOpenModalDelete}
        handleOpenEditModal={(currentTemplate) => onEditTemplate(currentTemplate.replace(/ +/g, '-'))}
      />

      {_.isEmpty(templates) && (
        <ZeroState fluid>
          {noItemsMessage}
        </ZeroState>
      )}

      {isModalDeleteOpen && (
        <ModalDelete
          show
          title="Delete template"
          warning="Warning: This cannot be undone"
          confirmText="Yes, delete template"
          cancelText="Cancel, keep template"
          handleClose={handleCloseModalDelete}
          handleConfirm={handleConfirmDeleteTemplate}
          errorMessage={deleteTemplateError && 'Something went wrong while deleting'}
          loading={deleteTemplateLoading}
        />
      )}
    </>
  );
};

TemplateBody.propTypes = {
  noItemsMessage: PropTypes.string.isRequired,
  templateType: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
  onEditTemplate: PropTypes.func.isRequired,
  onDeleteTemplate: PropTypes.func.isRequired,
  deleteTemplateError: PropTypes.bool,
  deleteTemplateLoading: PropTypes.bool.isRequired,
};

TemplateBody.defaultProps = {
  deleteTemplateError: false,
};

const mapStateToProps = ({ authentication }) => ({
  companyId: authentication.company?.id,
});

const enhance = compose(
  connect(mapStateToProps, null),
);

export default enhance(TemplateBody);
